import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.payments;
const cashBaseUrl = endpointNames.payments.cash;
const debitBaseUrl = endpointNames.payments.debitOrder
const currencies = endpointNames.currencies

let user = JSON.parse(localStorage.getItem('user'));
let token = JSON.parse(localStorage.getItem('token'));

//get all managers
const getAllPayments = async (t) => {
    let response;
    await axios.get(baseUrl.getAll, {
        headers: {Authorization: `Bearer ${t}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get all managers
const getAllCurrencies = async (t) => {
    let response;
    await axios.get(currencies, {
        headers: {Authorization: `Bearer ${t}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get manager details
const getPaymentDetails = async (id) => {
    let response;
    await axios.get(baseUrl + 'payment/' + id)
        .then(res => {
            console.log(res);
            response = res.data;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//add manager
const addCashPayment = async (request, policyId) => {
    let u = JSON.parse(localStorage.getItem('user'));
    console.log("user: ", u);
    let response;
    let data = {
        "amount": request.amount,
        "currency_id": 2,
        "reference_number": request.reference_number,
        "payment_channel": request.payment_channel,
        "user_id": u.id
    }
    console.log(request)
    console.log("policy id: ", policyId)
    await axios.post(cashBaseUrl + policyId, data, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const addDebitPayment = async (request, policyId) => {
    let u = JSON.parse(localStorage.getItem('user'));
    console.log("user: ", u);
    let response;
    let data = {
        "amount": request.amount,
        "reference_number": request.reference_number,
        "payment_channel": "Debit",
        "account_number": request.account_number,
        "account_name": request.account_name,
        "branch": request.branch,
        "bank_name": request.bank_name,
        "currency_id": 2,
        "user_id": u.id
    }
    console.log(request)
    console.log("policy id: ", policyId)
    await axios.post(debitBaseUrl + policyId, data, {

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update managers
const updatePayment = async (request) => {
    let response;
    await axios.put(baseUrl + 'payment', {
        'managerId': request.managerId,
        'name': request.name,
        'surname': request.surname,
        'email': request.email,
        'branch': request.branch
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//delete manager
const deletePayment = async (id) => {
    let response;
    await axios.delete(baseUrl + 'payment/' + id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//

export default {
    getAllPayments, getPaymentDetails, addCashPayment, updatePayment, deletePayment, getAllCurrencies, addDebitPayment
}
